<template>
  <v-app class="app-background">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="10" lg="8">
          <v-card elevation="10" class="rounded-xl overflow-hidden">
            <!-- Header -->
            <v-card-title class="primary white--text py-6 px-8">
              <v-icon large color="white" class="mr-4">mdi-doctor</v-icon>
              <div>
                <span class="text-h5 font-weight-bold d-block">Gestión de Profesionales</span>
                <span class="subtitle-2 white--text opacity-80">{{ dataUpdate ? 'Editar Datos del Profesional' : 'Nuevo Profesional' }}</span>
              </div>
            </v-card-title>

            <v-form ref="form" v-model="valid" @submit.prevent="validateCreateForm">
              <v-card-text class="pa-8">
                
                <v-row>
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                     <span class="text-caption grey--text">Los campos con asteriscos (*) son obligatorios</span>
                     <v-btn color="primary" text small @click="search" :loading="searchLoading">
                       <v-icon left>mdi-magnify</v-icon> Buscar por DNI
                     </v-btn>
                  </v-col>
                </v-row>
                
                <!-- Sección Identificación -->
                <span class="text-subtitle-1 font-weight-bold primary--text mb-4 mt-4 d-block">
                  <v-icon left color="primary">mdi-card-account-details</v-icon> Información Personal
                </span>
                
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="account_info.dni"
                      label="*DNI"
                      outlined dense
                      :rules="[v => !!v || 'Requerido']"
                      prepend-inner-icon="mdi-identifier"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="account_info.name"
                      label="*Nombre"
                      outlined dense
                      :rules="[v => !!v || 'Requerido']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="account_info.lastname"
                      label="*Apellido"
                      outlined dense
                      :rules="[v => !!v || 'Requerido']"
                    ></v-text-field>
                  </v-col>
                </v-row>
                
                <!-- Sección Profesional -->
                <span class="text-subtitle-1 font-weight-bold primary--text mb-4 mt-6 d-block">
                  <v-icon left color="primary">mdi-stethoscope</v-icon> Datos Profesionales
                </span>
                
                <v-row>
                  <v-col cols="12" md="6">
                     <v-select
                      v-model="account_info.gender"
                      :items="goptions"
                      item-text="text"
                      item-value="value"
                      label="*Género"
                      outlined dense
                      :rules="[v => !!v || 'Requerido']"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="account_info.matricula"
                      label="Matrícula"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                     <v-select
                      v-model="account_info.especialidad"
                      :items="especialidadOptions"
                      item-text="name"
                      item-value="value"
                      label="*Especialidad"
                      outlined dense
                      return-object
                      :rules="[v => !!v || 'Requerido']"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="account_info.telefono"
                      label="*Teléfono"
                      outlined dense
                      :rules="[v => !!v || 'Requerido']"
                      prepend-inner-icon="mdi-phone"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-divider class="my-6"></v-divider>

                <!-- Sección Horario de Trabajo -->
                <span class="text-subtitle-1 font-weight-bold primary--text mb-4 d-block">
                   <v-icon left color="primary">mdi-clock-outline</v-icon> Horario Base de Trabajo
                </span>
                
                <v-card outlined class="pa-4 mb-4 grey lighten-5">
                  <v-row align="center">
                    <v-col cols="12" md="3">
                       <v-select
                          v-model="dia"
                          :items="diaoptions"
                          item-text="text"
                          item-value="value"
                          label="Día"
                          dense outlined
                          hide-details="auto"
                          return-object
                      ></v-select>
                    </v-col>
                    <v-col cols="6" md="3">
                      <v-menu
                        ref="menuDesde"
                        v-model="menuDesde"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="desdeHora"
                            label="Inicio"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            dense outlined
                            hide-details="auto"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menuDesde"
                          v-model="desdeHora"
                          full-width
                          format="24hr"
                          @click:minute="$refs.menuDesde.save(desdeHora)"
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" md="3">
                        <v-menu
                        ref="menuHasta"
                        v-model="menuHasta"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="hastaHora"
                            label="Fin"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            dense outlined
                            hide-details="auto"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menuHasta"
                          v-model="hastaHora"
                          full-width
                          format="24hr"
                          @click:minute="$refs.menuHasta.save(hastaHora)"
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="duracion"
                        label="Dur. (min)"
                        type="number"
                        dense outlined
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1" class="d-flex justify-center">
                       <v-btn fab small color="primary" @click="agregarHorario">
                         <v-icon>mdi-plus</v-icon>
                       </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
                
                <!-- Lista de Horarios -->
                <v-list dense v-if="account_info.horarioTrabajo.length > 0" class="rounded-lg border">
                  <v-list-item v-for="(horario, index) in account_info.horarioTrabajo" :key="index">
                    <v-list-item-avatar>
                      <v-icon class="grey lighten-1 white--text">mdi-calendar-clock</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        {{ horario.dia.text }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ horario.desdeHora }} - {{ horario.hastaHora }} ({{ horario.duracion }} min)
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon color="error" @click="eliminarHorario(index)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <div v-else class="text-center caption grey--text py-2">
                   No hay horarios configurados
                </div>

              </v-card-text>

              <!-- Acciones -->
              <v-card-actions class="primary lighten-5 pa-6">
                <v-spacer></v-spacer>
                <v-btn
                  color="grey darken-1"
                  text
                  class="rounded-lg mr-2"
                  @click="limpiar"
                >
                  Limpiar
                </v-btn>
                <v-btn
                  color="primary"
                  class="rounded-lg px-8"
                  elevation="2"
                  type="submit"
                  :loading="loading"
                  :disabled="!valid"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  {{ dataUpdate ? 'Actualizar' : 'Guardar' }}
                </v-btn>
              </v-card-actions>
            </v-form>

            <!-- Loading Overlay -->
            <v-overlay :value="dialog" absolute>
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { getProfesionalByDni, getDataDr, createProfesionalHorario } from '@/services/monolito';
import { validationMixin } from 'vuelidate'

export default {
    name: "Profesional",
    mixins: [validationMixin],
    data() {
        return {
            valid: false,
            loading: false,
            searchLoading: false,
            
            menuDesde: false,
            menuHasta: false,
            
            account_info: {
                name: "",
                lastname: "",         
                dni:"",              
                active: true,
                matricula: "",
                especialidad: null,
                telefono:"",
                gender:"",
                horarioTrabajo: []
            },
            
            desdeHora: "12:00",
            hastaHora: "20:00",
            duracion: '30',
            
            dia: { text: 'LUNES', value: 'l' }, // Default object
            diaoptions: [
                { text: 'LUNES', value: 'l' },
                { text: 'MARTES', value: 'm' },
                { text: 'MIERCOLES', value: 'x' },
                { text: 'JUEVES', value: 'j' },
                { text: 'VIERNES', value: 'v' },
                { text: 'SABADO', value: 's' },
            ],
            
            goptions: [
                { text: 'MASCULINO', value: 'm' },
                { text: 'FEMENINO', value: 'f' }
            ],
            
            especialidadOptions: [],
            dialog: false,
            dataUpdate: false,
        }
    },
    created(){
        this.getInitialData()
    },
    methods: {
        async search() {
            if (!this.account_info.dni) {
               this.$toast.warning('Ingrese un DNI para buscar');
               return;
            }
            
            this.searchLoading = true;
            this.dialog = true;
            
            try {
                const data = await getProfesionalByDni(this.account_info.dni);
                
                if (!data || !Array.isArray(data) || data.length === 0) {
                    this.$toast.error('No se encontró el profesional.');
                    this.dialog = false; 
                    this.searchLoading = false;
                    return;
                }
                
                let datos = data[0];
                let contacto = data[1];
                let horario = data[2];
                
                this.account_info.gender = datos.party.gender.toLowerCase() == 'm' ? "MASCULINO" : "FEMENINO";
                this.account_info.name = datos.party.name;
                this.account_info.lastname = datos.party.lastname;
                this.account_info.matricula = datos.code;
                
                if (datos.specialty) {
                    // Buscar objeto completo en opciones
                    this.account_info.especialidad = this.especialidadOptions.find(e => e.value === datos.specialty.id) || null;
                }
                
                if (contacto) {
                    this.account_info.telefono = contacto.value;
                }
                
                if (horario) {
                    // Asumimos que viene con formato compatible o que backend maneja
                    this.account_info.horarioTrabajo = horario.horario_trabajo;
                }
                
                this.dataUpdate = true;
            } catch (error) {
                console.error('Error buscando:', error);
                this.$toast.error('Error en la búsqueda');
            } finally {
                this.dialog = false;
                this.searchLoading = false;
            }
        },
        
        limpiar() {
            this.account_info = {
                name: "",
                lastname: "",         
                dni: this.account_info.dni, // Mantener DNI si se quiere
                active: true,
                matricula: "",
                especialidad: null,
                telefono:"",
                gender:"",
                horarioTrabajo: []
            };
            this.dataUpdate = false;
            this.$refs.form.resetValidation();
        },
        
        eliminarHorario(index) {
            this.account_info.horarioTrabajo.splice(index, 1);
        },

        agregarHorario() {
            if (!this.dia || !this.desdeHora || !this.hastaHora || !this.duracion) {
                this.$toast.warning('Complete los campos del horario');
                return;
            }
            
            // Fix: ensure dia is object for display consistency
            let diaObj = this.dia; 
            // If user didn't change select, it might be default object. correct.
            
            let horario = {
                dia: diaObj, 
                desdeHora: this.desdeHora, 
                hastaHora: this.hastaHora, 
                duracion: this.duracion
            };
            
            this.account_info.horarioTrabajo.push(horario);
        },
        
        async getInitialData() {
            try {
                const response = await getDataDr();
                // response es array de {id, name}
                this.especialidadOptions = response.map(item => ({
                   value: item.id,
                   name: item.name
                }));
            } catch (error) {
                console.error('Error cargando especialidades:', error);
            }
        },
        
        async validateCreateForm() {
            if (!this.$refs.form.validate()) return;
            
            this.loading = true;
            this.dialog = true;
            
            try {
                await createProfesionalHorario(this.account_info);
                await this.$alert({ title: 'Éxito', message: 'Profesional guardado correctamente', color: 'success' });
            } catch (error) {
               if (error.response && error.response.status === 423) {
                    await this.$alert({ title: 'Usuario existente', message: 'Este usuario ya existe.', color: 'warning' });
                } else {
                    await this.$alert({ title: 'Error', message: 'Error guardando datos', color: 'error' });
                }
            } finally {
                this.loading = false;
                this.dialog = false;
            }
        },
    },
}
</script>

<style scoped>
.app-background {
  background: #f5f7fa; 
}
.opacity-80 {
  opacity: 0.8;
}
</style>
